"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const RetailOrderingAppWeb_1 = require("spg-common/compiled/src/apps/spg/ordering/components/RetailOrderingAppWeb");
if (!window.env.servicesUrl) {
    throw new Error("window.env.servicesUrl missing");
}
document.querySelectorAll("[data-inject]").forEach(element => {
    const getContent = () => {
        switch (element.getAttribute("data-inject")) {
            case "RetailOrderingApp":
                return React.createElement(RetailOrderingAppWeb_1.RetailOrderingAppWeb, null);
        }
    };
    ReactDOM.render(
    // hack: apply the general react styling via the 'react' class
    React.createElement("div", { className: "react" }, getContent()), document.getElementsByClassName("site")[0]);
});
//# sourceMappingURL=injectReactComponents.js.map